import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ActionButtonComponent } from "@components/action-button/action-button.component";
import { HeaderComponent } from "@components/header/header.component";
import { PageComponent } from "@components/page/page.component";
import { TranslatePipe } from "@ngx-translate/core";
import { Mottagningsplats } from "~app/common/models/lagerplats/MottagningsplatsListResponseDTO";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { SearchMottagningsplatsPanelComponent } from "./search-mottagningsplats-panel/search-mottagningsplats-panel.component";
import { SearchMottagningsplatsResultComponent } from "./search-mottagningsplats-result/search-mottagningsplats-result.component";

@Component({
    selector: "rask-search-mottagningsplats",
    templateUrl: "./search-mottagningsplats.component.html",
    styleUrls: ["./search-mottagningsplats.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        ActionButtonComponent,
        HeaderComponent,
        SearchMottagningsplatsPanelComponent,
        SearchMottagningsplatsResultComponent,
        TranslatePipe
    ]
})
export class SearchMottagningsplatsComponent {
    results: Mottagningsplats[];

    private readonly authenticationService = inject(AuthenticationService);
    private readonly router = inject(Router);

    canCreate(): boolean {
        return this.authenticationService.canEdit();
    }

    canCreateUtlandsk(): boolean {
        return (
            this.authenticationService.canEdit() &&
            this.authenticationService.hasRoles("RASK.Administrera")
        );
    }

    create(): void {
        this.router.navigate([
            "/mottagningsplats",
            "sverige",
            "ny"
        ]);
    }

    createUtlandsk(): void {
        this.router.navigate([
            "/mottagningsplats",
            "utlandsk",
            "ny"
        ]);
    }

    onResult(searchResult: any[]) {
        this.results = searchResult;
    }
}
